import React, { Component } from 'react'
import Upload from '../components/Upload'
import logo from '../assets/images/arctic-crowd-source-logo.png';

class UploadLayout extends Component {
  render () {
    const { profile } = this.props

    return (
      <div className="App" style={{ height: '100%' }}>
        <Upload profile={profile} style={{ height: '100%' }} />
      </div>
    )
  }
}

export default UploadLayout



// WEBPACK FOOTER //
// ./src/components/UploadContainer.js